import { useEffect, useRef, useState } from 'react';

const useSticky = (scrollableElement = null, error = 0) => {
   const stickyRef = useRef(null);
   const [isSticky, setSticky] = useState(false);
   const [offset, setOffset] = useState(0);
   const pageSection = useRef(null);

   useEffect(() => {
      pageSection.current = document.getElementById(scrollableElement || 'page_section');
   }, []);

   useEffect(() => {
      if (!stickyRef.current) {
         return;
      }
      setOffset(stickyRef.current.offsetTop - error);
   }, [stickyRef, setOffset]);

   useEffect(() => {
      const handleScroll = () => {
         if (!stickyRef.current) {
            return;
         }
         setSticky(pageSection.current.scrollTop > offset);
      };

      if (!pageSection.current) return;
      pageSection.current.addEventListener('scroll', handleScroll);
      return () => pageSection.current.removeEventListener('scroll', handleScroll);
   }, [setSticky, stickyRef, offset]);

   return { stickyRef, isSticky };
};

export default useSticky;
